/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FxIdDomainSettingsLauncherReviewSettings
 */
export interface FxIdDomainSettingsLauncherReviewSettings {
    /**
     * Number of days since installation before showing review prompt
     * @type {number}
     * @memberof FxIdDomainSettingsLauncherReviewSettings
     */
    DaysSinceInstall?: number | null;
    /**
     * Percentage of users who will see the review prompt, please -1 disable it
     * @type {number}
     * @memberof FxIdDomainSettingsLauncherReviewSettings
     */
    Percent?: number | null;
    /**
     * Whether to enable test mode
     * @type {boolean}
     * @memberof FxIdDomainSettingsLauncherReviewSettings
     */
    TestMode?: boolean | null;
    /**
     * Number of days to wait before showing another review prompt after the last one
     * @type {number}
     * @memberof FxIdDomainSettingsLauncherReviewSettings
     */
    DaysSinceLastReview?: number | null;
}

/**
 * Check if a given object implements the FxIdDomainSettingsLauncherReviewSettings interface.
 */
export function instanceOfFxIdDomainSettingsLauncherReviewSettings(value: object): value is FxIdDomainSettingsLauncherReviewSettings {
    return true;
}

export function FxIdDomainSettingsLauncherReviewSettingsFromJSON(json: any): FxIdDomainSettingsLauncherReviewSettings {
    return FxIdDomainSettingsLauncherReviewSettingsFromJSONTyped(json, false);
}

export function FxIdDomainSettingsLauncherReviewSettingsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdDomainSettingsLauncherReviewSettings {
    if (json == null) {
        return json;
    }
    return {
        
        'DaysSinceInstall': json['DaysSinceInstall'] == null ? undefined : json['DaysSinceInstall'],
        'Percent': json['Percent'] == null ? undefined : json['Percent'],
        'TestMode': json['TestMode'] == null ? undefined : json['TestMode'],
        'DaysSinceLastReview': json['DaysSinceLastReview'] == null ? undefined : json['DaysSinceLastReview'],
    };
}

export function FxIdDomainSettingsLauncherReviewSettingsToJSON(json: any): FxIdDomainSettingsLauncherReviewSettings {
    return FxIdDomainSettingsLauncherReviewSettingsToJSONTyped(json, false);
}

export function FxIdDomainSettingsLauncherReviewSettingsToJSONTyped(value?: FxIdDomainSettingsLauncherReviewSettings | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'DaysSinceInstall': value['DaysSinceInstall'],
        'Percent': value['Percent'],
        'TestMode': value['TestMode'],
        'DaysSinceLastReview': value['DaysSinceLastReview'],
    };
}

